'use es6';

import { READ, SENT } from '../constants/messageDeliveryStatuses';
export const getDeliveryStatus = (messageTimestamp, visitorLastReadTimestamp) => {
  return visitorLastReadTimestamp >= messageTimestamp ? READ : SENT;
};